let hamburgerButton = document.getElementById('hamburger-button');
let submenuLinkTrigger = document.querySelectorAll('.menu-header-nav__menu li > a:not([href])');
let mq = window.matchMedia("(min-width: 1024px)");

// Hamburger Menu
hamburgerButton.addEventListener('click', (e) => {
  let isOpen = hamburgerButton.getAttribute('aria-expanded') === 'false';
  let body = document.body;
  let top = window.scrollY || window.pageYOffset;

  if (isOpen) {
    body.style.top = -top + "px";
    body.setAttribute("data-scroll", top);
  }

  hamburgerButton.setAttribute('aria-expanded', isOpen);
  body.classList.toggle('is-menu-open', isOpen);

  // Scroll the body back to its initial position
  if (!isOpen) {
    var initialScroll = parseInt(body.getAttribute("data-scroll")) || 0;
    window.scrollTo({ top: initialScroll, behavior: "instant" });
  }
});

// Insert buttons for triggering sub-menus on mobile
document.querySelectorAll('.menu-header-nav__menu > li').forEach(function (menuItem) {
  if (menuItem.querySelector('.sub-menu')) {
    var button = document.createElement('button');
    button.innerHTML = '<svg width="13" height="8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.027 7.66 1.247 2.88c-.352-.352-.352-.879 0-1.195L2.02.875c.351-.316.878-.316 1.195 0l3.375 3.41L10 .875c.316-.316.844-.316 1.195 0l.774.809c.351.316.351.843 0 1.195L7.188 7.66a.828.828 0 0 1-1.16 0Z" fill="currentColor"/></svg><span class="visually-hidden">toggle submenu</span>';
    button.classList.add('submenu-button');

    var link = menuItem.querySelector('a');
    link.insertAdjacentElement('afterend', button);

    button.addEventListener('click', function () {
      toggleSubmenu(button)
    });
  }
});

// For menus with no top link, make the top link functional as well
submenuLinkTrigger.forEach(function(trigger) {
  trigger.addEventListener('click', function(event) {
      event.preventDefault();

      let button = trigger.nextElementSibling;
      toggleSubmenu(button);
  });
});


function toggleSubmenu(button) {
  if(!mq.matches) { // mobile only
    let submenu = button.nextElementSibling;
    let listItem = button.parentElement;
    let isOpen = button.getAttribute('aria-expanded') === 'true';
  
    submenu.style.maxHeight = isOpen ? null : submenu.scrollHeight + 'px';
    button.setAttribute('aria-expanded', !isOpen);
    listItem.classList.toggle('is-active');
  }
}

/** On ESC, close the hamburger menu */
document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    hamburgerButton.setAttribute('aria-expanded', false);
    document.body.classList.remove('is-menu-open');
  }
});